import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import InviteUserDialog from "./InviteUserDialog";
function InviteUser(props) {
  const {
    children,
    value,
    index,
    connectionDetails,
    activeUsers,
    service,
    handleInvite,
    allUsers,
    authenticatedUsers,
    ...other
  } = props;

  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(false);

  if (value != index) {
    return <></>;
  }

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {allUsers
        ?.filter((user) => !authenticatedUsers.includes(user?.email))
        ?.map((user) => (
          <Box key={user?.email} sx={{ p: 3 }}>
            <h3>Name: {`${user?.full_name}`}</h3>
            <p>Email: {`${user?.email}`}</p>
            <Button
              onClick={() => {
                setUser((prev) => user);
                setOpen((prev) => true);
              }}
            >
              Invite
            </Button>
          </Box>
        ))}

      <InviteUserDialog
        open={open}
        setOpen={setOpen}
        service={service}
        handleInvite={handleInvite}
        user={user}
      />
    </div>
  );
}

export default InviteUser;
